import apiClient from "./apiClient";
import { ApiCollectionResponse } from "../models/ResponseModels/ApiCollectionResponse";
import { ApiSingleResponse } from "../models/ResponseModels/ApiSingleResponse";
import { RecurringExpenseResponse } from "../models/ResponseModels/RecurringExpenseResponse";
import { CreateRecurringExpenseRequest } from "../models/RequestModels/CreateRecurringExpenseRequest";
import { UpdateRecurringExpenseRequest } from "../models/RequestModels/UpdateRecurringExpenseRequest";

interface GetRecurringExpensesParams {
  property_id?: number;
  unit_id?: number;
  currency?: string;
  active?: boolean;
}

export const getRecurringExpensesRequest = async (
  params?: GetRecurringExpensesParams,
): Promise<ApiCollectionResponse<RecurringExpenseResponse>> => {
  const response = await apiClient.get<
    ApiCollectionResponse<RecurringExpenseResponse>
  >("/recurring-expenses", { params });

  return response.data;
};

export const createRecurringExpenseRequest = async (
  body: CreateRecurringExpenseRequest,
): Promise<ApiSingleResponse<RecurringExpenseResponse>> => {
  const response = await apiClient.post<
    ApiSingleResponse<RecurringExpenseResponse>
  >("/recurring-expenses", body);

  return response.data;
};

export const updateRecurringExpenseRequest = async (
  id: number,
  body: UpdateRecurringExpenseRequest,
): Promise<ApiSingleResponse<RecurringExpenseResponse>> => {
  const response = await apiClient.put<
    ApiSingleResponse<RecurringExpenseResponse>
  >(`/recurring-expenses/${id}`, body);

  return response.data;
};

export const deleteRecurringExpenseRequest = async (
  id: number,
): Promise<void> => {
  await apiClient.delete(`/recurring-expenses/${id}`);
};
